import palette from '../../utils/colorPalette';
import { styled } from 'styled-components';

const Textarea = styled.textarea`
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.8rem;
  font-family: NotoSansKR-Light;
  transition: border-color 0.2s;
  color: ${palette.text.default};
  resize: none;
  &:focus {
    outline: none;
    border-color: ${palette.textfield.default};
  }
`;

export default Textarea;
